import { useEffect } from 'react';
import { SnackbarContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ChevronRight, CheckCircle } from '@material-ui/icons';
import styles from './Autorating.module.scss';
import sparkle from 'assets/icons/sparkle.svg';
import { useAutoratingStore } from './Autorating.store';
import classNames from 'classnames';
import { useGetAssessmentRatingQuery } from './Autorating.queries';
import Organization from 'infrastructure/Organization';
import { useShouldShowIAFeature } from 'hooks/IAFeaturesHook';

const useStylesBase = makeStyles({
  root: {
    boxShadow: 'none',
    padding: '1px 12px',
    marginBottom: '1rem',
    flexWrap: 'nowrap',
    width: '100% !important',
    boxSizing: 'border-box',
  },
});

const useStylesEdit = makeStyles({
  root: {
    backgroundColor: 'white',
    border: '1px solid #90a4ae',
    color: '#272d37',
  },
});

const useStylesUndo = makeStyles({
  root: {
    backgroundColor: 'rgba(240, 255, 250, 1)',
    border: '1px solid #2dc38d',
    color: '#2dc38d',
  },
});

const AutoratingSnackbars = ({ handleEditAIFeedback, submission_id }) => {
  const isFFEnabled = useShouldShowIAFeature('ai_assessments');

  const org_id = Organization.getSelectedOrg()?.id;
  const classesBase = useStylesBase();
  const classesEdit = useStylesEdit();
  const classesUndo = useStylesUndo();

  const filledWithAI = useAutoratingStore((state) => state?.filledWithAI);
  const saveEdition = useAutoratingStore((state) => state?.saveEdition);
  const reset = useAutoratingStore((state) => state?.reset);
  const setIsLoading = useAutoratingStore((state) => state?.setIsLoading);

  const { refetch, isLoading } = useGetAssessmentRatingQuery({
    org_id,
    submission_id,
    enabled: isFFEnabled,
  });

  useEffect(() => {
    if (!isFFEnabled) return;
    setIsLoading(isLoading);
  }, [isLoading, setIsLoading, isFFEnabled]);

  const handelEditAIRating = () => {
    handleEditAIFeedback();
  };

  const handleUndoAI = () => {
    reset();
    refetch();
  };

  const editAction = (
    <div
      onClick={handelEditAIRating}
      className={classNames(styles.actionContainer, styles.editColor)}
    >
      <span>Edit</span>
      <ChevronRight style={{ fontSize: '0.9rem', color: '#0494FD' }} />
    </div>
  );

  const undoAction = (
    <span onClick={handleUndoAI} className={classNames(styles.actionContainer, styles.undoColor)}>
      Undo
    </span>
  );

  if (!isFFEnabled) return null;

  return (
    <div>
      {filledWithAI && !saveEdition && (
        <SnackbarContent
          className={classNames(classesBase.root, classesEdit.root)}
          message={
            <div className={styles.messageContainer}>
              <img src={sparkle} alt="sparkle" style={{ width: '1.2rem', height: '1.2rem' }} />
              <div style={{ fontSize: '12px', color: '#272D37' }}>
                AI Provides rating automatically. Adjust the rating as needed
              </div>
            </div>
          }
          action={editAction}
        />
      )}

      {filledWithAI && saveEdition && (
        <SnackbarContent
          className={classNames(classesBase.root, classesUndo.root)}
          message={
            <div className={styles.messageContainer}>
              <CheckCircle fontSize="small" />
              <div>Feedback updated</div>
            </div>
          }
          action={undoAction}
        />
      )}
    </div>
  );
};

export default AutoratingSnackbars;
